export default "__VITE_ASSET__DFKBcK53__"